import { SessionAddress } from '@updater-core/interactors/shell/session/interactor.d';
import { Address } from '@updater-apps/move-your-stuff/interactors/mys/types';
import { format, parseISO } from '@updater-core/lib/date';
import { higherPricingArea } from '@updater-apps/move-your-stuff/interactors/mys/pricing-zips';

export function mapAddress({
  street,
  apt,
  city,
  state,
  zip,
}: Partial<SessionAddress>): Address {
  return {
    street,
    unit: apt,
    city,
    state,
    postalCode: zip,
  };
}

export function getAddressString({ street, city, state, postalCode }: Address) {
  const order = [`${street}`, city, `${state} ${postalCode}`];
  return order.join(',');
}

export function safeFormat(dateString, formatString) {
  try {
    return format(parseISO(dateString), formatString);
  } catch {
    return '';
  }
}

export function getFormattedDate(moveDate) {
  const dateTime = safeFormat(moveDate, 'MMMM do');

  const replacedDateTime = dateTime
    .replace('PM', 'pm')
    .replace('AM', 'am')
    .replace('February', 'Feb.')
    .replace('September', 'Sept.')
    .replace('August', 'Aug.')
    .replace('October', 'Oct.')
    .replace('November', 'Nov.')
    .replace('December', 'Dec.');

  return replacedDateTime;
}

export function getMovePricePoint({ homeSize, fromAddress, toAddress }) {
  const higherPricingZips = higherPricingArea.map(({ zipcode }) =>
    String(zipcode)
  );
  const higherPricingHomeSizeMap = {
    studio: '499',
    one_bed: '649',
    two_bed: '799',
    three_bed: '949',
  };
  const lowerPricingHomeSizeMap = {
    studio: '299',
    one_bed: '349',
    two_bed: '449',
    three_bed: '549',
  };
  const higherPricing =
    higherPricingZips.includes(fromAddress.postalCode) &&
    higherPricingZips.includes(toAddress.postalCode);

  const priceMap = higherPricing
    ? higherPricingHomeSizeMap
    : lowerPricingHomeSizeMap;
  const pricePoint = priceMap[homeSize];
  return pricePoint;
}
